import axiosInstance from "../config/axios.config";

export const getPharmacyPurchaseEntriesListApi = (params) => {
  return axiosInstance.get(`pharmacy/purchase-entries/?${params}`);
};

export const getPharmacyPurchaseEntryApi = (id) => {
  return axiosInstance.get(`pharmacy/purchase-entries/${id}/`);
};

export const addPharmacyPurchaseEntryApi = (payload) => {
  return axiosInstance.post(`pharmacy/purchase-entries/`, payload);
};

export const updatePharmacyPurchaseEntryApi = (id, payload) => {
  return axiosInstance.patch(`pharmacy/purchase-entries/${id}/`, payload);
};

export const addPharmacyPurchaseEntryItemApi = (entryId, payload) => {
  return axiosInstance.post(`pharmacy/purchase-entries/${entryId}/items/`, payload);
};

export const deletePharmacyPurchaseEntryItemApi = (itemId) => {
  return axiosInstance.delete(`pharmacy/purchase-entries/items/${itemId}/`);
};

export const completePharmacyPurchaseEntryApi = (entryId) => {
  return axiosInstance.post(`pharmacy/purchase-entries/${entryId}/complete/`, {});
};

/**
 * The whole entry at once - header and lines - replacing what is on the
 * server. Refused once the entry has been completed; a completed entry is
 * stock that has already moved.
 */
export const editPharmacyPurchaseEntryApi = (id, payload) => {
  return axiosInstance.put(`pharmacy/purchase-entries/${id}/edit/`, payload);
};

/** Only permitted while the entry is still a draft. */
export const cancelPharmacyPurchaseEntryApi = (id) => {
  return axiosInstance.post(`pharmacy/purchase-entries/${id}/cancel/`, {});
};

/**
 * Scans one or more supplier invoice files (images or PDFs) and returns the
 * parsed vendor, line items and GST summary.
 *
 * Content-Type is left unset so the browser adds the multipart boundary - the
 * client's default JSON header would otherwise make the upload unparseable.
 */
export const scanPharmacyInvoiceApi = (formData) => {
  return axiosInstance.post(
    "pharmacy/purchase-entries/scan-invoice/",
    formData,
    { headers: { "Content-Type": undefined } }
  );
};

/**
 * Every earlier purchase of one medicine - what was paid for it, from whom,
 * on which batch. The buying side of `pharmacy/bills/medicine-history/`, and
 * it takes the medicine the same way: `?medicine=<pharmacy_medicine_id>`.
 */
export const getPharmacyMedicinePurchaseHistoryApi = (params) => {
  return axiosInstance.get(`pharmacy/purchase-entries/medicine-history/?${params}`);
};

/*
 * Editing one line of an entry the server already holds.
 *
 * A line at a time, rather than the whole list through `edit/`. The PUT is a
 * replace - it removes anything left out of the payload - so correcting one
 * rate meant posting every line back, and every one of them was then logged
 * as changed. These three say exactly what moved.
 *
 * On a completed entry the server adjusts stock by the difference, and
 * refuses (400) where that stock has already been sold, returned or
 * transferred. Changing the medicine replaces the line, so its id changes -
 * which is why the screen re-reads the entry afterwards rather than patching
 * what it holds.
 */
export const addPharmacyPurchaseEntryEditItemApi = (entryId, payload) => {
  return axiosInstance.post(`pharmacy/purchase-entries/${entryId}/edit/items/`, payload);
};

export const updatePharmacyPurchaseEntryEditItemApi = (entryId, itemId, payload) => {
  return axiosInstance.patch(
    `pharmacy/purchase-entries/${entryId}/edit/items/${itemId}/`,
    payload
  );
};

export const removePharmacyPurchaseEntryEditItemApi = (entryId, itemId, payload) => {
  return axiosInstance.delete(
    `pharmacy/purchase-entries/${entryId}/edit/items/${itemId}/`,
    payload ? { data: payload } : undefined
  );
};
